/* src/app/shared/components/delivery-defense-terms-conditions-link/delivery-defense-terms-conditions-link.component.scss */
a {
  font-size: inherit;
  font-style: normal;
  font-weight: inherit;
  line-height: inherit;
  text-decoration-line: underline;
  color: #004791;
}
:host(.delivery-defense-terms-conditions-link) {
  display: inline;
}
/*# sourceMappingURL=delivery-defense-terms-conditions-link.component.css.map */
